<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="softwareSelectItems"
            v-model="item.software"
            :items="softwareSelectItems"
            :error-messages="softwareErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.strategy.software')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'ProfileStrategyForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.softwareGetSelectItems();
      this.profileStrategyQualitiesGetSelectItems();
  },
  data() {
    return {
        software: null,
        profileStrategyQualities: null,
    };
  },
  computed: {
      isLoading() {
        return (this.isLoading_softwareversion ||
           this.isLoading_profilestrategyquality
         );
      },
      ...mapFields('softwareversion', {
        softwareSelectItems: 'selectItems',
        isLoading_softwareversion : 'isLoading'
      }),
      ...mapFields('profilestrategyquality', {
        profileStrategyQualitiesSelectItems: 'selectItems',
        isLoading_profilestrategyquality : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },


    softwareErrors() {
      const errors = [];

      if (!this.$v.item.software.$dirty) return errors;

      has(this.violations, 'software') && errors.push(this.violations.software);


      return errors;
    },
    profileStrategyQualitiesErrors() {
      const errors = [];

      if (!this.$v.item.profileStrategyQualities.$dirty) return errors;

      has(this.violations, 'profileStrategyQualities') && errors.push(this.violations.profileStrategyQualities);


      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        softwareGetSelectItems: 'softwareversion/fetchSelectItems'
      }),
      ...mapActions({
        profileStrategyQualitiesGetSelectItems: 'profilestrategyquality/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      software: {
      },
      profileStrategyQualities: {
      },
    }
  }
};
</script>
